import {
  Component,
  ChangeDetectionStrategy,
  Input,
  inject,
} from '@angular/core';
import { SpenFlashMessage, SpenLink } from '@classi/spen';
import { GlobalMessageService } from '../global-message.service';

@Component({
  selector: 'app-global-message',
  imports: [SpenFlashMessage, SpenLink],
  templateUrl: './global-message.component.html',
  styleUrls: ['./global-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalMessageComponent {
  private readonly globalMessageService = inject(GlobalMessageService);

  @Input() isMarginTop: boolean = true;
  @Input() isMarginBottom: boolean = true;
  readonly globalMessage = this.globalMessageService.globalMessage;
}
